import { Action } from '@ngrx/store';

export enum CheckOutFeatureActionTypes {
  CheckOut = '[CheckOut] Check Out',
  CheckOutSuccess = '[CheckOut] Check Out Success',
  CheckOutFailure = '[CheckOut] Check Out Failure',
}

export class CheckOut implements Action {
  readonly type = CheckOutFeatureActionTypes.CheckOut;

  constructor(public payload: any) {}
}

export class CheckOutSuccess implements Action {
  readonly type = CheckOutFeatureActionTypes.CheckOutSuccess;
}

export class CheckOutFailure implements Action {
  readonly type = CheckOutFeatureActionTypes.CheckOutFailure;

  constructor(public payload?: { errorCode: string }) {}
}

export type CheckOutFeatureActions = CheckOut;
